import React, { Fragment } from 'react';
import './styles.css';
import { useHistory } from 'react-router';
import { Row, Col, Button } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleDown } from '@fortawesome/free-solid-svg-icons';
import { Item, DividerContainer, ButtonBackData } from '@BUP/components';
import Diagnostico from '@BUP/assets/Images/Data/data_diagnostico.png';
import Sociograma from '@BUP/assets/Images/Data/data_sociograma.png';
import QuienesResponden from '@BUP/assets/Images/Data/data_¿quienes-responden.png';
import Duracion from '@BUP/assets/Images/Data/data_¿duracion.png';
import QueNecesito from '@BUP/assets/Images/Data/data_¿que-necesito.png';
import QueRecursos from '@BUP/assets/Images/Data/data_¿que-recursos.png';
import QueMide from '@BUP/assets/Images/Data/data_¿que-mide.png';
import CuandoFinaliza from '@BUP/assets/Images/Data/data_¿cuando-finaliza.png';
import DiagnosticoConvivenciaEscolar from '@BUP/assets/Documents/Data/Presentación_instrumento_Diagnostico_Convivencia_Escolar.pdf';
import { useTranslation } from 'react-i18next';

const DataInstrumentsCounselor = () => {
  const history = useHistory();
  const [t] = useTranslation();

  return (
    <>
      <ButtonBackData onClick={() => history.goBack()} />
      <DividerContainer title={t('pages.data.instruments.dividerText1')} />

      <p className="instrumentsCounselor_paragraph">
        {t('pages.data.instruments.introText')}
      </p>
      <Row justify="space-around">
        <Col xs={24} sm={12} lg={8}>
          <Item
            src={Diagnostico}
            title={t('pages.data.instruments.diagnosticTitle')}
            description={t('pages.data.instruments.diagnosticDescriptionECE')}
          />
        </Col>
        <Col xs={24} sm={12} lg={8}>
          <Item
            src={Sociograma}
            title={t('pages.data.instruments.sociogramTitle')}
            description={t('pages.data.instruments.sociogramDescriptionECE')}
          />
        </Col>
      </Row>
      <DividerContainer title={t('pages.data.instruments.dividerText2')} />
      <Row>
        <Col xs={24} sm={12} lg={8}>
          <Item
            src={QuienesResponden}
            title={t('pages.data.instruments.whoAnswerTitle')}
            description={t('pages.data.instruments.whoAnswerDescriptionECE')}
          />
        </Col>
        <Col xs={24} sm={12} lg={8}>
          <Item
            src={Duracion}
            title={t('pages.data.instruments.durationTitle')}
            description={t('pages.data.instruments.durationDescriptionECE')}
          />
        </Col>
        <Col xs={24} sm={12} lg={8}>
          <Item
            src={QueNecesito}
            title={t('pages.data.instruments.whatINeedTitle')}
            description={t('pages.data.instruments.whatINeedDescriptionECE')}
          />
        </Col>
        <Col xs={24} sm={12} lg={8}>
          <Item
            src={QueRecursos}
            title={t('pages.data.instruments.resourcesTitle')}
            description={
              <ul>
                <li>{t('pages.data.instruments.resourcesDescription1ECE')}</li>
                <li>{t('pages.data.instruments.resourcesDescription2ECE')}</li>
              </ul>
            }
          />
        </Col>
        <Col xs={24} sm={12} lg={8}>
          <Item
            src={QueMide}
            title={t('pages.data.instruments.resourcesDescription2ECE')}
            description={t(
              'pages.data.instruments.whatMeasuresInstrumentDescriptionECE'
            )}
            downloadLink={
              <a
                className="instrumentsCounselor_item__download-text"
                target="_blank"
                href={DiagnosticoConvivenciaEscolar}
                rel="noreferrer"
              >
                {t('pages.data.instruments.whatMeasuresInstrumentLink')}
                <FontAwesomeIcon
                  className="download-icon"
                  icon={faArrowCircleDown}
                />
              </a>
            }
          />
        </Col>
        <Col xs={24} sm={12} lg={8}>
          <Item
            src={CuandoFinaliza}
            title={t('pages.data.instruments.whenItEndsTitle')}
            description={t('pages.data.instruments.whenItEndsDescriptionECE')}
          />
        </Col>
      </Row>

      <Row className="instrumentsCounselor_row-request">
        <Col span={24} align="end">
          <Button
            type="primary"
            size="large"
            className="instrumentsCounselor_row-request_button"
            onClick={() => history.push('/data/instruments/activation-steps')}
          >
            {t('pages.data.instruments.startActivationButton')}
          </Button>
        </Col>
      </Row>

      <DividerContainer title={t('pages.data.instruments.dividerText3')} />

      <Row justify="space-around">
        <Col xs={24} sm={12} lg={8}>
          <Item
            src={QuienesResponden}
            title={t('pages.data.instruments.whoCanAnswerTitle')}
            description={t(
              'pages.data.instruments.whoCanAnswerDescriptionTeacher'
            )}
          />
        </Col>
        <Col xs={24} sm={12} lg={8}>
          <Item
            src={Duracion}
            title={t('pages.data.instruments.howLongTitle')}
            description={t(
              'pages.data.instruments.durationSociogramDescriptionTeacher'
            )}
          />
        </Col>
        <Col xs={24} sm={12} lg={8}>
          <Item
            src={QueMide}
            title={t('pages.data.instruments.whatMeasuresTitle')}
            description={t('pages.data.instruments.whatMeasuresDescriptionECE')}
          />
        </Col>
        <Col span={24} align="start">
          <ButtonBackData onClick={() => history.goBack()} />
        </Col>
      </Row>
    </>
  );
};

export default DataInstrumentsCounselor;
